export default __webpack_public_path__ + "static/media/swiss-online-garantie@2x.1ad8799c.png";